<div class="menu-group">
  <h5 class="menu-heading caption-text" *ngIf="heading">{{ heading }}</h5>
  <ng-content></ng-content>
  <div class="divider"></div>
</div>
